import { Component, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'cd-header',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './cd-header.html',
  styleUrl: './cd-header.scss',
})
export class CdHeader {
  mobileMenuOpen = false;
  menuToggled = output<boolean>();

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    this.menuToggled.emit(this.mobileMenuOpen);
  }
}
